module.exports = __webpack_public_path__ + "img/quayWidth.cec2090f.svg";